import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Mail, LucideAngularModule } from 'lucide-angular';
import { ButtonComponent } from "../ui/button.component/button.component";

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, LucideAngularModule, ButtonComponent],
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  readonly MailIcon = Mail;
}
